export const APP_ID = '45842a23-e595-4b63-a8a4-75566efb0d81';
export const MACHINE_ID_COOKIE_NAME = 'in_machine_id';
